const translations = {
  cta: {
    expanded: "See less",
    minimized: "See more"
  },
  heading: "Connections"
};

export default translations;
